<template>
  <div class="dashboard background">
    <toast />
    <dashboard-page pcontent="1" page="TEACHERS">
      <!-- teacher manager  -->
      <card w='80%' minWidth='950px' v-if='this.teacherManage && !this.showEdit'>
        <!-- card header -->
        <div class='fRow fullWidth jStart aStart'>
          <div class='growFull fCol jStart aStart'>
            <h3 class='growFull text-right'>مدیریت دبیران</h3>
            <p class='note'>دبیران را اضافه، حذف، ویرایش و مشاهده کنید.</p>
          </div>
          <btn fabBtn='true' label='اضافه کردن' bc='#61187A'
            icon='add' @click.native="teacherAddToggle"/>
          <btn fabBtn='true' label='به روز رسانی' bc='#9a9a9a'
            style="margin-right: 8px !important;"
            icon='loop' @click.native="refreshAll"/>
        </div>
        <!-- <div class='sepLine'></div> -->
        <!-- filter list  -->
        <div class="filterLessons fullWidth fRow jStart aCenter">
          <div class="fullWidth fRow jStart aStart wrap" v-bind:class="{err: emptyError}">
            <p class='growFull'
            style="margin: 16px 0; text-align: right; width: calc(100%);">
              لیست دبیران را فیلتر کنید.</p>
            <div class="inputWrapper fCol aStart jStart ptitle" style="width: 170px;">
              <label class="rContainer checkBoxHolder dark fRow jStart aCenter fullWidth"
                id='showall' style="padding: 8px; margin-top: 16px">
                <input type="radio"
                name="parents"
                id='showAllLessons'
                class="parent fullWidth"
                    v-on:change="ch($event, 'all')"/>
                <div class="checkmark dark"></div>
                <div class="checkText fRow jCenter aCenter">
                  <div>مشاهده همه</div>
                </div>
              </label>
            </div>
            <div class="inputWrapper fCol aStart jStart ptitle growFull">
              <span>نام درس را جستجو و از لیست انتخاب کنید</span>
              <input @focus="openLessons" @input="filterLessonList" @blur="closeLessons"
                placeholder="مثلا: «ریاضی»" type="text" v-model="lessonTitle"/>
              <div class="dropDown fCol jStart aStart fullWidth" v-if="this.dropdown">
                <progress-bar v-if="!this.isLessonDataLoad" w='100%' h='100%'
                  msg='لطفا صبر کنید' load='true'/>
                <div class="fCol fullWidth jStart aStart" v-if="this.dropDownLoad">
                  <label v-bind:key="item.id" v-for="item in this.lessons"
                  class="rContainer checkBoxHolder lll dark fullWidth fRow jStart aCenter"
                  style="overflow: unset;">
                    <input type="radio"
                    name="lesson"
                    class="lesson"
                    :id='item.id'
                    :data-title='`${item.title} ${item.gradeName} ${sayFieldName(item.field)}`'
                    v-on:change="ch($event, 'filter')"/>
                    <div class="checkmark dark fRow jCenter aCenter"></div>
                    <div class="checkText fCol jStart aCenter">
                      <div>{{item.title}} {{item.gradeName}} ({{sayFieldName(item.field)}})</div>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class='sepLine'></div>
        <!-- grid header -->
        <div class='gridHead gridRow fRow jBetween fullWidth' v-if="false">
          <div class='tableHead itemImg'>تصویر</div>
          <div class='tableHead title big' style="text-align: right;">مشخصات</div>
          <div class='tableHead state'>وضعیت</div>
          <div class='tableHead state'>قطع دسترسی</div>
          <div class='tableHead actions big'>عملیات</div>
        </div>
        <empty-bar v-if="responseEmpty" w='100%' h='152px'
          msg='شما هنوز هیچ دبیری ثبت نکرده اید'/>
        <error-bar v-if="responseError" w='100%' h='152px'
          :msg='errorMsg'/>
        <progress-bar v-if="!isDataLoad" w='100%' h='160px'
          msg='لطفا صبر کنید'/>
        <div class="fullWidth fCol aCenter jStart" v-if="isDataLoad">
          <teacher-row
            v-bind:key="item.id"
            v-for="(item, index) in TeacherDatas"
            @refresh="refreshAll"
            @edit="goEdit($event)"
            :index='((activePage - 1) * pageSize) + index + 1'
            :data='item' />
        </div>
        <pagination v-if="isDataLoad" :active='activePage' :psize='pageSize'
        @resetPageSize="resetPageSize($event)"
        :pages='howManyPages' @goToPage="GoToPages($event)" />
      </card>
      <!-- ▬▬▬▬↓↓↓ teacher add ↓↓↓▬▬▬▬ -->
      <card w='80%' minWidth='950px' v-if='teacherAdd'>
        <!-- hameye content bad az load shodan inja show mishan ↓ -->
        <div class="fCol jStart aStart" v-if="showAddNow">
          <!-- card header -->
          <div class='fRow fullWidth jStart aStart'>
            <div class='growFull fCol jStart aStart'>
              <h3 class='growFull text-right'>
                {{editMode ? `ویرایش مشخصات ${editData.fullName}` : 'َاضافه کردن مدرس جدید'}}
              </h3>
              <p class='note'>
                {{editMode ? 'اطلاعات مدرس را ویرایش و ذخیره کنید'
                  : 'برای اضافه کردن دبیر جدید فرم زیر را پر کنید. تمام فیلدها اجباری می‌باشند'}}
              </p>
            </div>
            <btn fabBtn='false' label='بازگشت' bc='#9a9a9a'
              icon='keyboard_arrow_left' @click.native="teacherAddToggle"/>
          </div>
          <div class='sepLine'></div>
          <!-- Add teacher form  -->
          <div class="fullWidth fRow wrap jBetween aStart formHolder">
            <div class="fullWidth fRow jBetween aCenter">
              <div class="inputHolder fCol aStart jStart">
                <span class="fRow jStart aCenter" style="margin-bottom: 8px">
                  <i class="material-icons-round"
                    v-bind:class="{inpErr: tAvatarErr}">add_a_photo</i>
                  آواتار مدرس را انتخاب کنید</span>
                <get-photo
                  w='100%'
                  style="margin-top: -8px"
                  v-on:photoupload="getUploaded"
                  photoFor='teacher'
                  :initImg='this.computedInitImage'
                  uploadMsg='آپلود تصویر الزامیست'
                  uploadLabel='تصویر دبیر'/>
              </div>
              <div class="fRow jBetween aStart growFull wrap" style="margin-right: 16px">
                <div class="w50 fCol jStart aStart inputHolder">
                  <span class="fRow jStart aCenter">
                    <i class="material-icons-round"
                      v-bind:class="{inpErr: nameErr}">account_circle</i>
                    نام مدرس - {{name.length}}/24</span>
                  <div class="fRow jStart aCenter fullWidth inputWraper">
                    <input
                      class="transition-fast" placeholder="نام مدرس"
                      type="text" v-model="name">
                  </div>
                </div>
                <div class="w50 fCol jStart aStart inputHolder">
                  <span class="fRow jStart aCenter">
                    <i class="material-icons-round"
                      v-bind:class="{inpErr: lastNameErr}">account_circle</i>
                    نام خانوادگی - {{lastName.length}}/24</span>
                  <div class="fRow jStart aCenter fullWidth inputWraper">
                    <input
                      class="transition-fast" placeholder="نام خانوادگی مدرس"
                      type="text" v-model="lastName">
                  </div>
                </div>
                <div class="w50 fCol jStart aStart inputHolder">
                  <span class="fRow jStart aCenter">
                    <i class="material-icons-round"
                      v-bind:class="{inpErr: phoneErr}">phone_iphone</i>
                    شماره همراه - {{phone.length}}/11</span>
                  <div class="fRow jStart aCenter fullWidth inputWraper">
                    <input
                      class="transition-fast" placeholder="شماره همراه"
                      type="number" v-model="phone">
                  </div>
                </div>
                <div class="w50 fCol jStart aStart inputHolder"
                  v-if="!editMode || (editMode && letEditAccess)">
                  <span class="fRow jStart aCenter">
                    <i class="material-icons-round"
                      v-bind:class="{inpErr: accessErr}">tune</i>
                    انتخاب دسترسی</span>
                    <cool-select
                      class="fullWidth"
                      @select="selected($event, 'access')"
                      v-model="access"
                      disable-search
                      :items="accesses"
                      :item-value="accesses.id"
                      :item-text="accesses.title">
                      <!-- slot for each item in the menu -->
                      <template slot="item" slot-scope="{ item: accesses }">
                        <div style="display: flex; align-items: center;">
                          <div>
                            {{ accesses.title }}
                          </div>
                        </div>
                      </template>
                      <!-- slot for the selected item (in the text access) -->
                      <template slot="selection" slot-scope="{ item: accesses }">
                        <div>
                          {{ accesses.title }}
                        </div>
                      </template>
                    </cool-select>
                </div>
                <div class="w50 fCol jStart aStart inputHolder" v-if="editMode && !letEditAccess">
                  <span class="fRow jStart aCenter">
                    <i class="material-icons-round"
                      v-bind:class="{inpErr: false}">tune</i>
                    دسترسی</span>
                  <div class="fRow jBetween aCenter fullWidth access">
                    {{editData.access.title}}
                    <div class="b fRow jStart aCenter mini flat" @click="letEditAccess = true">
                      <i class="material-icons-round">edit</i>
                      <label>ویرایش</label>
                    </div>
                  </div>
                </div>
                <div class="w50 inputHolder fCol aStart jStart">
                  <span class="fRow jStart aCenter">
                    <i class="material-icons-round">
                      {{status ? 'toggle_off' : 'toggle_on'}}
                    </i>
                    وضعیت مدرس - {{username.length}}/8</span>
                  <div class="fRow jStart aCenter fullWidth" @click="status = !status">
                    <p class="growFull rtlText" style="padding-right: 12px;">وضعیت دبیر</p>
                    <switch-button
                      id="teacherStatus"
                      :val="status"
                      activeLabel="فعال"
                      deactiveLabel="غیرفعال"
                    />
                  </div>
                </div>
                <div class="w25 fCol jStart aStart inputHolder" v-if="!editMode">
                  <span class="fRow jStart aCenter">
                    <i class="material-icons-round"
                      v-bind:class="{inpErr: usernameErr}">fingerprint</i>
                    نام کاربری - {{username.length}}/8</span>
                  <div class="fRow jStart aCenter fullWidth username" @click="makeUsername">
                    {{username}}
                  </div>
                </div>
                <div class="w25 fCol jStart aStart inputHolder" v-if="!editMode">
                  <span class="fRow jStart aCenter">
                    <i class="material-icons-round"
                      v-bind:class="{inpErr: passwordErr}">password</i>
                    رمز عبــور - {{password.length}}/8</span>
                  <div class="fRow jStart aCenter fullWidth username" @click="makePassWord">
                    {{password}}
                  </div>
                </div>
              </div>
            </div>
            <div class="fullWidth fCol jStart aStart inputHolder" style="min-height: 480px">
              <span class="fRow jStart aCenter">
                <i class="material-icons-round"
                  v-bind:class="{inpErr: selectedClasses.length < 1}">menu_book</i>
                انتخاب درس‌ها
              </span>
              <div class="fullWidth fRow jBetween aStart consultantHolder wrap">
                <div class="fullWidth fRow jStart aStart header wrap">
                  <span class="t">درسهای مربوط به دبیر را انتخاب کنید:</span>
                  <input type="text" class="search fullWidth"
                    placeholder="نام درس را جستجو کنید"
                    v-model="classSearch">
                </div>
                <div class="items w60 fRow jBetween aCenter wrap">
                  <h2 class="fullWidth"
                    v-if="filteredClasses.length !== 0">درس ها را انتخاب کنید
                    از بین ({{filteredClasses.length}} درس)
                  </h2>
                  <div class="item fRow jStart aCenter fullWidth transition-fast"
                    @click="selectClass(item.id)"
                    v-bind:class="{
                      selectedItem: selectedClasses.includes(item.id)
                    }"
                    v-for="(item, index) in filteredClasses" v-bind:key="index">
                    <i class="check material-icons-round">
                      {{!selectedClasses.includes(item.id)
                        ? 'radio_button_unchecked' : 'task_alt'}}
                    </i>
                    <div class="av"
                      v-bind:style="{
                        backgroundImage: `url('https://api.rimik.ir/${item.photo}')`,
                      }">
                    </div>
                    <div class="growFull fCol jCenter aStart">
                      <span class="name">{{item.title}}</span>
                      <div class="mini">{{item.info}}</div>
                    </div>
                  </div>
                  <div class="noResult fCol fullWidth jCenter aCenter"
                    v-if="filteredClasses.length === 0">
                    <i class="material-icons-round">error</i>
                    <span>نتیجه‌ای یافت نشد</span>
                    <div class="mini" @click="classSearch = ''">حذف فیلتر</div>
                  </div>
                </div>
                <div class="selectedItems w40 fCol jStart aCenter">
                  <h2 class="fullWidth">درس های انتخاب شده:</h2>
                  <div class="item fRow jStart aCenter fullWidth transition-fast"
                    v-for="(item, index) in selectedClassItems" v-bind:key="index">
                    <span class="index">{{index + 1}}</span>
                    <div class="fCol jCenter aStart growFull">
                      <span class="name growFull">{{item.title}}</span>
                      <div class="mini">{{item.info}}</div>
                    </div>
                    <i class="ac material-icons-round"
                      @click="deleteClass(item.id)">delete</i>
                  </div>
                  <div class="noResult fCol fullWidth jCenter aCenter"
                    v-if="selectedClassItems.length === 0">
                    <i class="material-icons-round">error</i>
                    <span>هیچ درسی انتخاب نشده</span>
                    <!-- <div class="mini"></div> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="w50 fCol jStart aStart inputHolder">
              <span class="fRow jStart aCenter">
                <i class="material-icons-round"
                  v-bind:class="{inpErr: shortDescErr}">short_text</i>
                توضیحات کوتاه - {{shortDesc.length}}/24</span>
              <div class="fRow jStart aCenter fullWidth inputWraper">
                <textarea
                  class="transition-fast" placeholder="توضیحات کوتاه دربارۀ مدرس"
                  type="text" v-model="shortDesc"></textarea>
              </div>
            </div>
            <div class="w50 fCol jStart aStart inputHolder">
              <span class="fRow jStart aCenter">
                <i class="material-icons-round"
                  v-bind:class="{inpErr: descErr}">subject</i>
                توضیحات کامل - {{desc.length}}/24</span>
              <div class="fRow jStart aCenter fullWidth inputWraper">
                <textarea
                  class="transition-fast" placeholder="توضیحات کامل دربارۀ مدرس"
                  type="text" v-model="desc"></textarea>
              </div>
            </div>
            <div class="btnsRow fRow jStart aCenter fullWidt" style="margin-top: 32px">
              <div class="b fRow jCenter aCenter big"
                @click="createNewTeacher"
                v-if="!editMode"
                v-bind:class="{active: newTeacherFormIsReady}">
                <i class="material-icons-round">done_all</i>
                <label>ثبت مدرس جدید</label>
              </div>
              <div class="b fRow jCenter aCenter big"
                @click="editTeacher"
                v-if="editMode"
                v-bind:class="{active: editTeacherFormIsReady}">
                <i class="material-icons-round">save</i>
                <label>ذخیرۀ تغییرات {{editData.fullName}}</label>
              </div>
              <div class="b fRow jCenter aCenter"
                @click="clearForm">
                <i class="material-icons-round">close</i>
                <label>{{editMode ? 'انصراف و بازگشت' : 'پاک کردن فرم'}}</label>
              </div>
            </div>
          </div>
        </div>
        <!-- <empty-bar v-if="responseEmpty" w='100%' h='152px'
          msg='شما هنوز هیچ دسترسی ای ثبت نکرده اید'/>
        <error-bar v-if="responseError" w='100%' h='152px'
          :msg='errorMsg'/> -->
        <progress-bar v-if="!showAddNow" w='100%' h='160px'
          msg='لطفا صبر کنید'/>
      </card>
      <!-- ▬▬▬▬↑↑↑ teacher add ↑↑↑ ▬▬▬▬ -->
      <!--                                              -->
      <!-- ▌▌▌▌▌▌▌↓↓↓ teacher edit ↓↓↓▌▌▌▌▌▌▌ -->
      <card w='80%' minWidth='950px' v-if='this.showEdit'>
        <!-- hameye content bad az load shodan inja show mishan ↓ -->
        <div class="fCol jStart aStart" v-if="this.teacherEdit">
          <!-- card header -->
          <div class='fRow fullWidth jStart aStart'>
            <div class='growFull fCol jStart aStart'>
              <h3 class='growFull text-right'>ویرایش مشخصات دبیر</h3>
              <p class='note'>
                برای ویرایش دبیر فرم زیر را پر کنید. تمام فیلدها اجباری می‌باشند.
              </p>
            </div>
            <btn fabBtn='false' label='بازگشت' bc='#9a9a9a'
              icon='keyboard_arrow_left' @click.native="backToList"/>
          </div>
          <div class='sepLine'></div>
          <!-- Add teacher form  -->
          <div class="fullWidth fRow wrap jBetween aStart formHolder">
            <div class="inputWrapper fCol aStart jStart w33">
              <inp len='50' inputType='text' place='مثلا علیرضا'
                :initData='this.tName.data' req='true' validation='name'
                @vmodel='getFromInput($event, "name")'
                icon='account_circle' label='نام دبیر را وارد کنید' />
            </div>
            <div class="inputWrapper fCol aStart jStart w33">
              <inp len='50' inputType='text' place='مثلا احمدیان'
                :initData='this.tLastname.data' req='true' validation='lname'
                @vmodel='getFromInput($event, "lname")'
                icon='account_circle' label='نام خانوادگی دبیر را وارد کنید' />
            </div>
            <div class="inputWrapper fCol aStart jStart w33">
              <inp len='11' min='11' inputType='number' place='مثلا 09305943207'
                :initData='this.tMobile.data' req='true' validation='phone'
                @vmodel='getFromInput($event, "mobile")'
                icon='phone_iphone' label='شماره همراه دبیر را وارد کنید' />
            </div>
            <div class="inputWrapper fCol aStart jStart w50">
              <inp noLimit='true' inputType='text' place='انتخاب از لیست'
                :list='this.filteredAccesses' compType='radio' req='true'
                :initData='this.tAccess' from='edit'
                @vmodel='getFromInput($event, "access")'
                icon='admin_panel_settings' label='انتخاب دسترسی دبیر' />
            </div>
            <div class="inputWrapper fCol aStart jStart w50">
              <inp noLimit='true' inputType='text' place='انتخاب از لیست'
                :list='this.filteredLessons' compType='checkbox' req='true'
                :initData='this.tLessons' from='edit'
                @vmodel='getFromInput($event, "lessons")'
                icon='menu_book' label='انتخاب درس‌ها' />
            </div>
            <div class="inputWrapper fCol aStart jStart w50">
              <inp len='120' inputType='text' place='خلاصه' compType='textarea'
                :initData='this.tSummary.data'
                lines=2 @vmodel='getFromInput($event, "summary")'
                icon='short_text' label='توضیحات کوتاه' />
              <inp len='120' inputType='text'
                place='متن توضیحات کامل را وارد کنید' compType='textarea'
                :initData='this.tDescription.data'
                lines=4 @vmodel='getFromInput($event, "desc")'
                icon='subject' label='توضیحات کامل' />
            </div>
            <div class="inputWrapper fCol aStart jStart w50">
              <div class="top-row fRow jStart aCenter">
                <p>تصویر دبیر را آپلود کنید</p>
              </div>
              <get-photo
                w='100%'
                style="margin-top: -8px"
                v-on:photoupload="getUploaded"
                photoFor='teacher'
                :initImg='this.tAvatar'
                uploadMsg='آپلود تصویر الزامیست'
                uploadLabel='تصویر دبیر'/>
            </div>
            <btn label="آپدیت مشخصات دبیر" btnWidth='70%'
              class="flexGrow"
              icon="save" @click.native="editTeacher"/>
          </div>
        </div>
        <!-- <empty-bar v-if="responseEmpty" w='100%' h='152px'
          msg='شما هنوز هیچ دسترسی ای ثبت نکرده اید'/>
        <error-bar v-if="responseError" w='100%' h='152px'
          :msg='errorMsg'/> -->
        <progress-bar v-if="!this.teacherEdit" w='100%' h='160px'
          msg='لطفا صبر کنید'/>
      </card>
      <!-- ▌▌▌▌▌▌▌↑↑↑ teacher edit ↑↑↑ ▌▌▌▌▌▌▌ -->
      <modal v-if="computedModalState" @changeMsg="refreshAll()">
        <card :w="`${computedCardWidth}`">
        <!-- add / edit lesson -->
          <teacher-manager v-if="computedWorkOn" @changeMsg="refreshAll()"
          :mode='computedMode'/>
        </card>
      </modal>
    </dashboard-page>
    <tool-bar/>
    <right-menu/>
  </div>
</template>

<script>
import RightMenu from '@/components/RightMenu.vue';
import ToolBar from '@/components/ToolBar.vue';
import DashboardPage from '@/components/DashboardPage.vue';
import Card from '@/components/Card.vue';
import Btn from '@/components/Btn.vue';
import Inp from '@/components/Inp.vue';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';
import Toast from '@/components/Toast.vue';
import ticks from '@/mixins/ticks';
import fp from '@/mixins/fp';
import SwitchButton from '@/components/SwitchButton.vue';
import ProgressBar from '@/components/ProgressBar.vue';
import ErrorBar from '@/components/ErrorBar.vue';
import EmptyBar from '@/components/EmptyBar.vue';
import Pagination from '@/components/Pagination.vue';
import axios from 'axios';
import Modal from '@/components/Modal.vue';
import GetPhoto from '@/components/GetPhoto.vue';
// کامپوننت های مربوط به teacher
import TeacherRow from '@/components/TeacherRow.vue';
import TeacherManager from '@/components/teacher/TeacherManager.vue';
import { CoolSelect } from 'vue-cool-select';
import 'vue-cool-select/dist/themes/material-design-dark.scss';
import '@/assets/new.scss';

export default {
  mixins: [errorHandler, makeToast, ticks, fp],
  data() {
    return {
      // true = manage mode, false = add mode ↓
      teacherManage: true,
      teacherAdd: false,
      teacherEdit: false,
      TeacherDatas: [],
      teacherStatus: true,
      lessonTitle: '',
      dropDownLessons: [],
      lessonsDatas: [],
      lessons: [],
      lastLesson: '',
      dropDownLoad: false,
      dropdown: false,
      isLessonDataLoad: false,
      howManyPages: 0,
      pageSize: 10,
      activePage: 1,
      // data for add teacher ↓
      letShowAddPage: false,
      lessonsLoaded: false,
      allLessons: [],
      filteredLessons: [],
      accessesLoaded: false,
      allAccesses: [],
      filteredAccesses: [],
      filter: 0,
      testList: [
        {
          value: '465221351',
          label: 'آیتم اول',
        },
        {
          value: '846135483',
          label: 'آیتم دوم',
        },
        {
          value: '135546846',
          label: 'آیتم سوم',
        },
      ],
      // v models ↓
      tName: { data: '' },
      tLastname: { data: '' },
      tUsername: { data: '' },
      tPassword: { data: '' },
      tAccess: { data: '' },
      tLessons: [],
      tMobile: { data: '' },
      tStatus: 1,
      tSummary: { data: '' },
      tDescription: { data: '' },
      tLock: false,
      // new ↑
      isDataLoad: false,
      responseFalse: false,
      responseError: false,
      responseEmpty: false,
      selectedGradeToShow: 0,
      emptyError: false,
      gradeArrayByField: [],
      plsWait: false,
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      modalManager: this.$store.state.modalState,
      // new  teacher datas
      tAvatar: '',
      tAvatarErr: true,
      name: '',
      nameErr: true,
      lastName: '',
      lastNameErr: true,
      phone: '',
      status: true,
      phoneErr: true,
      username: '',
      usernameErr: true,
      password: '',
      passwordErr: true,
      accesses: [
        {
          id: -1,
          title: 'کمی صبر کنید...',
        },
      ],
      access: '',
      accessErr: true,
      shortDesc: '',
      shortDescErr: true,
      desc: '',
      descErr: true,
      // lessons list
      // select lessons for class for students
      classes: [],
      selectedClasses: [],
      selectedClassesErr: true,
      classSearch: '',
      selectedClassItems: [],
      editData: {},
      editMode: false,
      letEditAccess: false,
    };
  },
  methods: {
    backToList() {
      this.clearForm();
      this.teacherAddToggle();
      this.teacherEdit = false;
      this.$store.commit('setTeacherEditFalse');
    },
    getEditInitData() {
      if (this.$store.state.teacherEdit) {
        this.teacherManage = false;
        // alert(this.$store.state.focusedTeacherId);
        // eslint-disable-next-line
        const reqUrl = `${this.baseURL}/api/v${this.V}/Teachers/${this.$store.state.focusedTeacherId}`;
        axios({
          method: 'get',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
        }).then((response) => {
          // JSON responses are automatically parsed.
          this.posts = response.data;
          if (this.posts.isSuccess) {
            const resp = response.data.data;
            this.tName.data = resp.user.firstName;
            this.tLastname.data = resp.user.lastName;
            this.tMobile.data = resp.user.mobile.replace('98', '0');
            this.tUsername.data = resp.user.lastName;
            this.tDescription.data = resp.teacher.description;
            this.tSummary.data = resp.teacher.summary;
            this.tAvatar = resp.user.avatar;
            this.tAccess.data = resp.user.accessId;
            this.tLessons = resp.teacher.lessonIds;
            this.teacherEdit = true;
          }
          return this.$store.state.teacherEdit;
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 3000);
          this.teacherEdit = false;
          // console.log(error);
        });
      }
      this.teacherManage = true;
      return false;
    },
    GoToPages(event) {
      // بر اساس درس میگیریم لیست معلما رو
      // اگه درس نداشته باشیم ورودی تابع میشه 0 که همه رو بر میگردونه
      // اگه درس یا فیلتر داشته باشیم ورودی تابع میشه آی دی درس
      let getTeacherFilter = 0;
      if (this.filter !== 0) {
        getTeacherFilter = this.filter;
      }
      if (event === 'next') {
        // alert('next');
        this.activePage += 1;
        if (this.activePage > this.howManyPages) {
          this.activePage = 1;
        }
        this.getTeachers(getTeacherFilter, this.activePage);
        return;
      }
      if (event === 'prev') {
        this.activePage -= 1;
        if (this.activePage < 1) {
          this.activePage = this.howManyPages;
        }
        this.getTeachers(getTeacherFilter, this.activePage);
        return;
      }
      this.getTeachers(getTeacherFilter, event);
      this.activePage = event;
    },
    resetPageSize(e) {
      this.pageSize = e;
      this.activePage = 1;
      this.getTeachers(0);
    },
    clearForm() {
      // alert('clear form');
      this.name = '';
      this.lastName = '';
      this.phone = '';
      this.makePassWord();
      this.makeUsername();
      this.shortDesc = '';
      this.desc = '';
      this.selectedClasses = [];
      this.access = '';
      this.accessErr = true;
      this.tAvatar = '';
      this.editMode = false;
      this.letEditAccess = false;
      this.editData = {};
    },
    teacherFormValidation() {
      // name
      if (this.tName.error || this.tName.data === '') {
        this.makeToast('error', 'نام دبیر را وارد کنید', 3000);
        return false;
      }
      // lname
      if (this.tLastname.error || this.tLastname.data === '') {
        this.makeToast('error', 'نام خانوادگی دبیر را وارد کنید', 3000);
        return false;
      }
      // mobile
      if (this.tMobile.error) {
        this.makeToast('error', 'شماره همراه را درست وارد کنید', 1000);
        return false;
      }
      // username
      if (this.tUsername.error) {
        this.makeToast('error', 'نام کاربری را بررسی کنید', 1000);
        return false;
      }
      // password
      if (this.tPassword.error) {
        this.makeToast('error', 'رمز عبور را بررسی کنید', 1000);
        return false;
      }
      // access
      if (this.tAccess.data === '') {
        this.makeToast('error', 'دسترسی دبیر را انتخاب کنید', 1000);
        return false;
      }
      // lessons
      if (this.tLessons.length === 0) {
        this.makeToast('error', 'دروس مربوط به دبیر را انتخاب کنید', 1000);
        return false;
      }
      // avatar
      if (this.tAvatar === '') {
        this.makeToast('error', 'تصویر دبیر را آپلود کنید', 1000);
        return false;
      }
      return true;
    },
    createNewTeacher() {
      if (this.newTeacherFormIsReady) {
        axios({
          method: 'post',
          url: `${this.baseURL}/api/v${this.V}/Teachers`,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            Username: this.username,
            Password: this.password,
            AccessId: this.access.id,
            FirstName: this.name,
            LastName: this.lastName,
            Status: this.status,
            phoneNumber: this.phone,
            Avatar: this.tAvatar,
            Summary: this.shortDesc,
            Description: this.desc,
            LessonIds: this.selectedClasses,
          },
        }).then(
          (response) => {
            // console.log(response);
            if (response.data.isSuccess) {
              this.clearForm();
              this.teacherAddToggle();
              this.getTeachers(0);
            } else {
              this.makeToast('warning', 'نام کاربری تکراری است. لطفا نام کاربری جدید وارد کنید.', 4000);
            }
          },
          (error) => {
            this.whileState = false;
            // console.log(error);
            this.makeToast('error', this.errorHandler(error), 2000);
          },
        );
      }
    },
    editTeacher() {
      if (this.editTeacherFormIsReady) {
        axios({
          method: 'put',
          url: `${this.baseURL}/api/v${this.V}/Teachers/${this.editData.teacherId}`,
          headers: {
            Authorization: this.$authObeject.authToken(),
            'Content-Type': 'application/json',
          },
          data: {
            accessId: this.letEditAccess ? this.access.id : this.editData.access.id,
            firstName: this.name,
            lastName: this.lastName,
            phoneNumber: this.phone,
            summary: this.shortDesc,
            avatar: this.tAvatar,
            description: this.desc,
            lessonIds: this.selectedClasses,
          },
        }).then(
          (response) => {
            if (response.data.isSuccess) {
              this.clearForm();
              this.backToList();
              this.getTeachers(0);
            }
          },
          (error) => {
            this.whileState = false;
            // console.log(error);
            this.makeToast('error', this.errorHandler(error), 2000);
          },
        );
      }
    },
    changeTeacherStatus() {
      this.teacherStatus = !this.teacherStatus;
      // console.log('ch');
    },
    teacherAddToggle() {
      if (!this.teacherAdd) {
        this.teacherAdd = true;
        this.initAddTeacher();
        this.teacherManage = false;
      } else {
        this.teacherAdd = false;
        this.teacherManage = true;
        this.clearForm();
      }
    },
    initAddTeacher() {
      // first get lessons and make a filtered list
      this.lessonsLoaded = false;
      const reqUrl = `${this.baseURL}/api/v${this.V}/Lessons`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        this.posts = response.data;
        if (this.posts.isSuccess) {
          this.lessonsLoaded = true;
          this.allLessons = JSON.parse(JSON.stringify(this.posts.data));
          let lessonObject = {};
          this.filteredLessons = [];
          for (let i = 0; i < this.allLessons.length; i += 1) {
            lessonObject = {};
            lessonObject.value = this.allLessons[i].id;
            // eslint-disable-next-line
            lessonObject.label = `${this.allLessons[i].title} (${this.allLessons[i].gradeName} ${this.sayFieldName(this.allLessons[i].field)})`;
            this.filteredLessons.push(lessonObject);
          }
          // console.log('all filtered ▄░▄░▄░▄░▄░▄', this.filteredLessons);
        } else {
          this.makeToast('error', 'خطا در دریافت اطلاعات', 3000);
        }
      }, (error) => {
        this.lessonsLoaded = false;
        this.makeToast('error', this.errorHandler(error), 3000);
      }).then(() => {
        // then get access and make a filtered list
        this.accessesLoaded = false;
        const reqUrlAccess = `${this.baseURL}/api/v${this.V}/Accesses`;
        axios({
          method: 'get',
          url: reqUrlAccess,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
        }).then((response) => {
          this.posts = response.data;
          if (this.posts.isSuccess) {
            this.accessesLoaded = true;
            this.allAccesses = JSON.parse(JSON.stringify(this.posts.data));
            let a = {};
            this.accesses = [];
            for (let i = 0; i < this.allAccesses.length; i += 1) {
              a = {
                id: this.allAccesses[i].id,
                title: this.allAccesses[i].title,
              };
              this.accesses.push(a);
            }
            // console.log('all accesses ▄░▄░▄░▄░▄░▄', this.filteredAccesses);
          } else {
            this.makeToast('error', 'خطا در دریافت اطلاعات', 3000);
          }
        }, (error) => {
          this.accessesLoaded = false;
          this.makeToast('error', this.errorHandler(error), 3000);
        });
      });
    },
    sayFieldName(num) {
      let sfn = '';
      switch (num) {
        case 0: {
          sfn = 'متوسطه‌ی اول';
          break;
        }
        case 1: {
          sfn = 'ریاضی فیزیک';
          break;
        }
        case 2: {
          sfn = 'علوم تجربی';
          break;
        }
        case 3: {
          sfn = 'انسانی';
          break;
        }
        case 4: {
          sfn = 'فنی';
          break;
        }
        case 5: {
          sfn = 'هنر';
          break;
        }
        case 6: {
          sfn = 'زبان';
          break;
        }
        default:
          break;
      }
      return sfn;
    },
    getUploaded(event) {
      this.tAvatar = event;
    },
    getFromInput(event, inp) {
      switch (inp) {
        case 'name': {
          this.tName = event;
          // console.log(this.tName.data, event.error, event.warn);
          break;
        }
        case 'lname': {
          this.tLastname = event;
          // console.log(this.tLastname.data, event.error, event.warn);
          break;
        }
        case 'username': {
          this.tUsername = event;
          // console.log(this.tUsername.data, event.error, event.warn);
          break;
        }
        case 'password': {
          this.tPassword = event;
          // console.log(this.tPassword.data, event.error, event.warn);
          break;
        }
        case 'summary': {
          this.tSummary = event;
          // console.log(this.tSummary.data, event.error, event.warn);
          break;
        }
        case 'desc': {
          this.tDescription = event;
          // console.log(this.tDescription.data, event.error, event.warn);
          break;
        }
        case 'mobile': {
          this.tMobile = event;
          // console.log(this.tMobile.data, event.error, event.warn);
          break;
        }
        case 'access': {
          this.tAccess = event;
          break;
        }
        case 'lessons': {
          this.tLessons = event;
          // console.log(event);
          break;
        }
        default:
          break;
      }
    },
    filterLessonList() {
      // console.log(this.lessonTitle);
      if (this.lessonTitle === '') {
        this.lessons = this.lessonsDatas;
      } else {
        this.lessons = [];
        for (let i = 0; i < this.lessonsDatas.length; i += 1) {
          if (this.lessonsDatas[i].title.includes(this.lessonTitle)) {
            this.lessons.push(this.lessonsDatas[i]);
          }
        }
      }
    },
    closeLessons() {
      // console.log('close Lessons');
      setTimeout(() => {
        this.dropDownLoad = false;
        this.dropdown = false;
        this.lessonTitle = this.lastLesson;
      }, 300);
    },
    openLessons() {
      this.dropdown = true;
      this.dropDownLoad = false;
      axios({
        method: 'get',
        url: `${this.baseURL}/api/v${this.V}/Lessons`,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        // JSON responses are automatically parsed.
        this.posts = response.data;
        if (this.posts.isSuccess) {
          // اگه درست بود همه چی
          // this.lessonsDatas = JSON.parse(JSON.stringify(this.posts));
          this.dropDownLessons = JSON.parse(JSON.stringify(response.data.data));
          this.lessonsDatas = JSON.parse(JSON.stringify(this.posts.data));
          this.lessons = JSON.parse(JSON.stringify(this.posts.data));
          // console.log('╪┘╪┘╪┘╪┘╪┘╪┘', this.dropDownLessons);
          // اگه لیست خالی بود
          this.dropDownLoad = true;
        } else {
          this.dropDownLoad = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    changeTab() {
      this.teacherManage = !this.teacherManage;
    },
    ch(event, type) {
      switch (type) {
        case 'filter': {
          document.getElementById('showAllLessons').checked = false;
          this.activePage = 1;
          this.filter = event.target.id;
          this.getTeachers(this.filter, this.activePage);
          this.lessonTitle = event.target.getAttribute('data-title');
          this.lastLesson = event.target.getAttribute('data-title');
          break;
        }
        case 'all': {
          this.activePage = 1;
          this.getTeachers(0);
          this.lessonTitle = '';
          this.lastLesson = '';
          this.filter = 0;
          break;
        }
        default:
          break;
      }
    },
    refreshAll() {
      this.activePage = 1;
      this.getTeachers(0);
    },
    addLessons() {
      // console.clear();
      // console.log('dokmeye add zade shod');
      this.$store.commit('setWorkOn', 'lessons');
      this.$store.commit('setLessonAddMode');
      this.$store.commit('openLessonCard', '');
    },
    getLessonss(f) {
      // alert(f);
      this.isLessonDataLoad = false;
      this.responseFalse = false;
      this.responseEmpty = false;
      this.responseError = false;
      this.responseLoad = true;
      let reqUrl = `${this.baseURL}/api/v${this.V}/Lessons`;
      if (f !== 0) {
        reqUrl = `${this.baseURL}/api/v${this.V}/Lessons?gradeId=${f}`;
      }
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        // JSON responses are automatically parsed.
        this.responseLoad = false;
        this.posts = response.data;
        if (this.posts.isSuccess) {
          // this.makeToast('info', 'اطلاعات پایه های تحصیلی با موفقیت دریافت شد', 2000);
          this.responseFalse = false;
          // اگه درست بود همه چی
          this.isLessonDataLoad = true;
          this.lessonsDatas = JSON.parse(JSON.stringify(this.posts.data));
          this.lessons = JSON.parse(JSON.stringify(this.posts.data));
          // console.log('all lessons █▄█▄█data', this.lessons);
          // اگه لیست خالی بود
          if (this.posts.data.length === 0) {
            this.responseEmpty = true;
          } else {
            this.responseEmpty = false;
          }
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.responseError = true;
        this.isLessonDataLoad = true;
        this.responseEmpty = false;
        this.responseFalse = false;
        this.responseLoad = false;
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    getTeachers(f, p) {
      // alert(f);
      this.isDataLoad = false;
      this.responseFalse = false;
      this.responseEmpty = false;
      this.responseError = false;
      this.responseLoad = true;
      let tpage = 1;
      if (p !== undefined) {
        tpage = p;
      }
      // eslint-disable-next-line
      let reqUrl = `${this.baseURL}/api/v${this.V}/Teachers/?type=1&query=null&pageNo=${tpage}&pageSize=${this.pageSize}`;
      if (f !== 0) {
        // eslint-disable-next-line
        reqUrl = `${this.baseURL}/api/v${this.V}/Teachers?type=2&query=${f}&pageNo=${tpage}&pageSize=${this.pageSize}`;
      }
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        // JSON responses are automatically parsed.
        this.responseLoad = false;
        this.posts = response.data;
        if (this.posts.isSuccess) {
          // this.makeToast('info', 'اطلاعات پایه های تحصیلی با موفقیت دریافت شد', 2000);
          this.responseFalse = false;
          // اگه درست بود همه چی
          this.isDataLoad = true;
          this.TeacherDatas = JSON.parse(JSON.stringify(response.data.data.teachers));
          // this.TeacherDatas = this.TeacherDatas.slice().reverse();
          this.howManyPages = response.data.data.pageCount;
          // console.clear();
          // console.log(this.howManyPages);
          // console.log('all ███████ data', JSON.parse(JSON.stringify(this.TeacherDatas)));
          // اگه لیست خالی بود
          if (response.data.data.teachers.length === 0) {
            this.responseEmpty = true;
            // console.log('hey hey hey hey', this.responseEmpty);
          } else {
            this.responseEmpty = false;
          }
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.responseError = true;
        this.isDataLoad = true;
        this.responseEmpty = false;
        this.responseFalse = false;
        this.responseLoad = false;
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    getSortedGrades() {
      // گرفتن لیست گرید ها برای چک باکس
      this.plsWait = true;
      axios({
        method: 'get',
        url: `${this.baseURL}/api/v${this.V}/Lessons`,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        // console.log('from lesson manager in edit mode →', response.data.data);
        if (response.data.isSuccess) {
          this.initCheckBoxs(response);
          // console.log('response az lesson manager edit',
          //   JSON.parse(JSON.stringify(this.gradeArrayByField)));
        }
      }, (error) => {
        // console.log(error);
        this.makeToast('error', this.errorHandler(error), 2000);
      });
    },
    initCheckBoxs(response) {
      const gParent = {};
      const gData = {};
      const riaziObject = {};
      const riazi = [];
      const payeAvalObject = {};
      const payeAval = [];
      const tajrobiObject = {};
      const tajrobi = [];
      const ensaniObject = {};
      const ensani = [];
      const faniObject = {};
      const fani = [];
      const honarObject = {};
      const honar = [];
      const zabanObject = {};
      const zaban = [];
      // const ensani = [];
      // const fani = [];
      // const honar = [];
      // const zaban = [];
      for (let t = 0; t < response.data.data.length; t += 1) {
        gData.title = response.data.data[t].title;
        gData.id = response.data.data[t].id;
        gParent.title = '';
        switch (response.data.data[t].field) {
          case 0: {
            payeAval.push(response.data.data[t]);
            break;
          }
          case 1: {
            riazi.push(response.data.data[t]);
            break;
          }
          case 2: {
            tajrobi.push(response.data.data[t]);
            break;
          }
          case 3: {
            ensani.push(response.data.data[t]);
            break;
          }
          case 4: {
            fani.push(response.data.data[t]);
            break;
          }
          case 5: {
            honar.push(response.data.data[t]);
            break;
          }
          case 6: {
            zaban.push(response.data.data[t]);
            break;
          }
          default:
            break;
        }
      }
      payeAvalObject.data = payeAval;
      payeAvalObject.parent = 'متوسطه‌ی اول';
      payeAvalObject.parentId = 1;
      this.gradeArrayByField.push(payeAvalObject);
      // -|/-\|- //
      riaziObject.data = riazi;
      riaziObject.parent = 'ریاضی و فیزیک';
      riaziObject.parentId = 1;
      this.gradeArrayByField.push(riaziObject);
      // -|/-\|- //
      tajrobiObject.data = tajrobi;
      tajrobiObject.parent = 'علوم تجربی';
      tajrobiObject.parentId = 2;
      this.gradeArrayByField.push(tajrobiObject);
      // -|/-\|- //
      ensaniObject.data = ensani;
      ensaniObject.parent = 'علوم انسانی';
      ensaniObject.parentId = 3;
      this.gradeArrayByField.push(ensaniObject);
      // -|/-\|- //
      faniObject.data = fani;
      faniObject.parent = 'فنی';
      faniObject.parentId = 4;
      this.gradeArrayByField.push(faniObject);
      // -|/-\|- //
      honarObject.data = honar;
      honarObject.parent = 'هنر';
      honarObject.parentId = 5;
      this.gradeArrayByField.push(honarObject);
      // -|/-\|- //
      zabanObject.data = zaban;
      zabanObject.parent = 'زبان';
      zabanObject.parentId = 6;
      this.gradeArrayByField.push(zabanObject);
    },
    initUserData() {
      // این اول صفحه اجرا میشه
      if (this.$store.state.fp === 'undefined') {
        this.fpGenerator().then(() => {
          this.$authObeject.checkDate().then((result) => {
            if (result) {
              // console.log('توکن منقضی شده، درخواست ریفرش توکن');
            } else {
              this.initPage();
            }
          });
        });
      } else {
        this.initPage();
      }
    },
    initPage() {
      // اینیت اولیه پیج
      setTimeout(() => {
        document.getElementById('showall').click();
        this.getLessons(0);
        this.getSortedGrades();
      }, 1000);
    },
    // new functions
    makeUsername() {
      let username = '';
      let rand = 0;
      for (let i = 0; i < 8; i += 1) {
        rand = Math.floor(Math.random() * (122 - 97)) + 97;
        username += String.fromCharCode(rand);
      }
      this.username = username;
      // alert(pass);
    },
    makePassWord() {
      let pass = '';
      let rand = 0;
      rand = Math.floor(Math.random() * (90 - 65)) + 65;
      pass += String.fromCharCode(rand);
      rand = Math.floor(Math.random() * (90 - 65)) + 65;
      pass += String.fromCharCode(rand);
      rand = Math.floor(Math.random() * (57 - 48)) + 48;
      pass += String.fromCharCode(rand);
      rand = Math.floor(Math.random() * (57 - 48)) + 48;
      pass += String.fromCharCode(rand);
      rand = Math.floor(Math.random() * (57 - 48)) + 48;
      pass += String.fromCharCode(rand);
      rand = Math.floor(Math.random() * (57 - 48)) + 48;
      pass += String.fromCharCode(rand);
      rand = Math.floor(Math.random() * (122 - 97)) + 97;
      pass += String.fromCharCode(rand);
      rand = Math.floor(Math.random() * (122 - 97)) + 97;
      pass += String.fromCharCode(rand);
      this.password = pass;
      // alert(pass);
    },
    selected(e, dropDown) {
      switch (dropDown) {
        case 'access': {
          if (this.access.id !== -1) {
            this.accessErr = false;
          } else {
            this.accessErr = true;
          }
          break;
        }
        default:
          break;
      }
    },
    // get lesson
    getLessons(f) {
      let reqUrl = `${this.baseURL}/api/v${this.V}/Lessons`;
      if (f !== 0) {
        reqUrl = `${this.baseURL}/api/v${this.V}/Lessons?gradeId=${f}`;
      }
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        const res = response.data.data;
        if (response.data.isSuccess) {
          if (res.length === 0) {
            // this.responseEmpty = true;
          } else {
            this.classes = [];
            for (let i = 0; i < res.length; i += 1) {
              const a = {
                id: res[i].id,
                title: res[i].title,
                photo: res[i].photo,
                info: `${res[i].grade.title}، رشتۀ ${res[i].grade.field.title}`,
              };
              this.classes.push(a);
            }
          }
        } else {
          this.makeToast('error', 'خطایی رخ داده', 3000);
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    selectClass(id) {
      const isThere = this.selectedClasses.indexOf(id);
      if (isThere === -1) {
        this.selectedClasses.push(id);
      } else {
        this.selectedClasses.splice(isThere, 1);
      }
      // console.log(this.selectedClasses);
    },
    deleteClass(i) {
      // console.log(i);
      const index = this.selectedClasses.indexOf(i);
      this.selectedClasses.splice(index, 1);
    },
    goEdit(e) {
      this.teacherAddToggle();
      this.editData = e;
      this.editMode = true;
      this.name = e.firstName;
      this.lastName = e.lastName;
      this.phone = e.mobile.replace('989', '09');
      this.selectedClasses = [];
      for (let i = 0; i < e.lessons.length; i += 1) {
        this.selectedClasses.push(e.lessons[i].id);
      }
      this.shortDesc = e.summary;
      this.desc = e.description;
      this.tAvatar = e.avatar;
      // this.access = {
      //   id: e.accesses[0].id,
      //   title: e.accesses[0].title,
      // };
      this.accessErr = false;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.makeUsername();
      this.makePassWord();
      this.initUserData();
    });
  },
  components: {
    ProgressBar,
    ErrorBar,
    EmptyBar,
    RightMenu,
    ToolBar,
    DashboardPage,
    Card,
    Btn,
    GetPhoto,
    Pagination,
    SwitchButton,
    Inp,
    Toast,
    TeacherRow,
    TeacherManager,
    Modal,
    CoolSelect,
  },
  computed: {
    showAddNow() {
      let san = false;
      if (this.accessesLoaded && this.lessonsLoaded) {
        san = true;
      }
      return san;
    },
    showEdit() {
      if (this.$store.state.teacherEdit) {
        this.initAddTeacher();
        this.getEditInitData();
      }
      return this.$store.state.teacherEdit;
    },
    computedInitImage() {
      const cii = 'none';
      if (this.editMode) {
        return this.editData.avatar;
      }
      return cii;
    },
    computedModalState() {
      return this.$store.state.modalState;
    },
    computedCardWidth() {
      let ww = '0';
      switch (this.$store.state.teacherManagerMode) {
        case 'add': {
          ww = '980px';
          break;
        }
        case 'edit': {
          ww = '980px';
          break;
        }
        case 'delete': {
          ww = '426px';
          break;
        }
        default:
          break;
      }
      // console.log(this.$store.state.permissionManagerMode, ww);
      return ww;
    },
    computedWorkOn() {
      let cwo = false;
      switch (this.$store.state.workOn) {
        case 'teachers': {
          cwo = true;
          break;
        }
        default:
          break;
      }
      return cwo;
    },
    computedMode() {
      // alert(this.$store.state.teacherManagerMode);
      return this.$store.state.teacherManagerMode;
    },
    computedEmpty() {
      return this.emptyError;
    },
    filteredClasses() {
      // eslint-disable-next-line
      return this.classes.filter((item) => item.title.toLowerCase().includes(this.classSearch.toLowerCase()));
    },
    newTeacherFormIsReady() {
      return !this.nameErr
        && !this.lastNameErr
        && !this.phoneErr
        && !this.accessErr
        && !this.usernameErr
        && !this.passwordErr
        && !this.selectedClassesErr
        && !this.shortDescErr
        && !this.tAvatarErr
        && !this.descErr;
    },
    editTeacherFormIsReady() {
      return !this.nameErr
        && !this.lastNameErr
        && !this.phoneErr
        && !(!this.letEditAccess ? false : this.accessErr)
        && !this.selectedClassesErr
        && !this.shortDescErr
        && !this.tAvatarErr
        && !this.descErr;
    },
  },
  watch: {
    selectedClasses() {
      this.selectedClassItems = [];
      for (let i = 0; i < this.classes.length; i += 1) {
        if (this.selectedClasses.includes(this.classes[i].id)) {
          this.selectedClassItems.push(this.classes[i]);
        }
      }
      if (this.selectedClasses.length === 0) {
        this.selectedClassesErr = true;
      } else {
        this.selectedClassesErr = false;
      }
    },
    name() {
      const a = this.name;
      const l = 24;
      if (a.length > l) {
        this.name = this.name.substr(0, l);
      }
      this.nameErr = a.length < 2;
    },
    lastName() {
      const a = this.lastName;
      const l = 24;
      if (a.length > l) {
        this.lastName = this.lastName.substr(0, l);
      }
      this.lastNameErr = a.length < 2;
    },
    phone() {
      const phonePattern = /^\(?([0-9]{4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (this.phone.length > 11) {
        this.phone = this.phone.substr(0, 11);
        // console.log(this.message);
        this.phoneErr = false;
      }
      if (this.phone.match(phonePattern)
        && this.phone.charAt(0) === '0'
        && this.phone.charAt(1) === '9') {
        this.phoneErr = false;
      } else {
        this.phoneErr = true;
      }
    },
    username() {
      const a = this.username;
      const l = 12;
      if (a.length > l) {
        this.username = this.username.substr(0, l);
      }
      this.usernameErr = a.length < 6;
    },
    password() {
      const a = this.password;
      const l = 12;
      if (a.length > l) {
        this.password = this.password.substr(0, l);
      }
      this.passwordErr = a.length < 6;
    },
    shortDesc() {
      const a = this.shortDesc;
      const l = 140;
      if (a.length > l) {
        this.shortDesc = this.shortDesc.substr(0, l);
      }
      this.shortDescErr = a.length < 2;
    },
    desc() {
      const a = this.desc;
      const l = 280;
      if (a.length > l) {
        this.desc = this.desc.substr(0, l);
      }
      this.descErr = a.length < 2;
    },
    tAvatar() {
      this.tAvatarErr = this.tAvatar === '';
    },
    letEditAccess() {
      if (this.letEditAccess) {
        this.access = '';
        this.accessErr = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.filters {
  padding: 16px 0 0 0;
}

.checkText{

}

input:disabled{
  display: none;
}

.filters label{
  width: 20%;
}

.formHolder{
  margin-top: 16px;
}

.inputWrapper{
    margin-bottom: 24px;
    position: relative;
}

.inputWrapper .inputIcon{
  position: absolute;
  top: 32px;
  right: 8px;
  color: #61187a50;
  pointer-events: none;
}

.hasIcon{
  padding-right: 36px !important;
}

.inputWrapper span{
    font-size: 10px;
    padding-right: 8px;
    margin-bottom: 8px;
}

.inputWrapper input, .dropDownBtn{
    border: solid 2px rgba($color: #000000, $alpha: 0.2);
    border-radius: 4px;
    width: 100%;
    padding: 0px 12px;
    position: relative;
    height: 40px;
    transition: all ease-in-out 0.3s;
}

#showAllLessons {
  display: none;
}

.lesson{
  display: none;
}

.dropDownBtn{
  width: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.inputValue{
  font-size: 14px;
  text-align: right;
}

.inputWrapper .hide{
  opacity: 0;
  transform: scale(0);
}

.inputWrapper input:focus{
    border: solid 2px rgba($color: #000000, $alpha: 0.4);
    outline: none;
    border-radius: 8px;
    width: 100%;
    padding: 8px 12px;
}

.inputWrapper .dropDown{
    position: absolute;
    top: calc(24px + 40px);
    left: 0px;
    width: 100%;
    height: 200px;
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 264px;
    background-color: white;
    box-shadow: 0 8px 32px 0 rgba($color: #000000, $alpha: 0.25);
    border-radius: 8px;
    z-index: 300;
}

.lll {
  border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.05);
}

.lll:hover{
  background-color: #0000001e;
}

.inputWrapper .err {
  border-color: red;
  color: red;
}

.inputWrapper .dropDown .item{
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 200;
    color: black;
    text-align: right;
    cursor: pointer;
    transition: all ease-in-out 0.3s;
}

.item.icon{
    width:  25% !important;
    height: 40px !important;
    display: flex;
    border-radius: 80px;
    justify-content: center;
    align-items: center;
    font-size: 24px !important;
}

.inputWrapper .dropDown .item:hover{
    background-color: rgba($color: #000000, $alpha: 0.00);
    color: #61187A;
}

.top-row {
  padding: 8px 12px 0px 12px;
  color: rgb(71, 71, 71);
}

.top-row p {
  padding: 0;
  margin: 0;
  flex-grow: 1;
  color: rgb(71, 71, 71);
  font-size: 12px;
  margin-bottom: 8px;
  text-align: right;
}

.username {
  padding: 8px 16px;
  border-radius: 16px;
  background-color: rgba($color: #000000, $alpha: 0.05);
  margin-top: 8px;
  letter-spacing: 2px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
}

.access {
  padding: 8px 16px;
  border-radius: 16px;
  background-color: rgba($color: #000000, $alpha: 0.05);
  margin-top: 8px;
}

  .consultantHolder {
    input.search {
      outline: 0;
      margin-top: 16px;
      padding: 8px 16px;
      border: solid 1px rgba($color: #000000, $alpha: 0.35);
    }
    padding: 16px;
    .header {
      padding-bottom: 16px;
      margin-bottom: 16px;
      border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.25);
      span.t {
        font-size: 14px;
        text-align: right;
        margin-left: 16px;
        color: black;
      }
      .filters {
        span.o {
          font-size: 12px;
          font-weight: bold;
          margin-left: 16px;
        }
        .cheap {
          padding: 4px 8px;
          border-radius: 24px;
          background-color: rgba($color: #000000, $alpha: 0.05);
          font-size: 12px;
          margin-left: 8px;
          cursor: pointer;
        }
        .cheap.selected {
          background-color: rgba($color: #273a64, $alpha: 1);
          box-shadow: 0 12px 12px -12px rgba($color: #000000, $alpha: 1);
          color: white;
        }
      }
    }
    .items {
      max-height: 300px;
      overflow: hidden auto;
      padding: 16px;
      padding-bottom: 8px;
      border-radius: 16px;
      border: solid 2px rgba($color: #000000, $alpha: 0.05);
      .item {
        border-radius: 16px;
        padding: 8px;
        margin-bottom: 8px;
        border: solid 2px rgba($color: #000000, $alpha: 0.05);
        cursor: pointer;
        * {
          pointer-events: none;
          user-select: none;
        }
        .av {
          background-color: rgba($color: #000000, $alpha: 0.05);
          border-radius: 64px;
          $www: 48px;
          width: $www;
          height: $www;
          margin-left: 8px;
          overflow: hidden;
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
          img {
            width: 100%;
            height: 100%;
          }
        }
        i.check {
          margin-left: 8px;
        }
        span.name {
          font-size: 13px;
          font-weight: bold;
          color: #303030;
          text-align: right;
        }
        span.type {
          font-size: 12px;
          font-weight: 200;
          color: #646464;
        }
        .mini {
          font-size: 10px;
        }
      }
      .item.gone {
        display: none;
      }
      .item:nth-child(2n+1) {
        background-color: rgba($color: #000000, $alpha: 0.0);
      }
      .item:hover {
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
      .item.selectedItem {
        border: solid 2px rgba($color: #19b146, $alpha: 0.85) !important;
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
    }
    h2 {
      padding: 0;
      margin: 0 0 16px 0;
      font-size: 14px;
      padding-bottom: 16px;
      border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.05);
    }
    .selectedItems {
      padding: 16px;
      border-radius: 16px;
      border: solid 2px rgba($color: #000000, $alpha: 0.05);
      .item {
        border-radius: 24px 8px 8px 24px;
        padding: 4px 8px 4px 4px;
        cursor: pointer;
        span.index {
          margin-left: 4px;
          font-size: 10px;
          text-align: right;
          min-width: 16px;
          width: 16px;
          line-height: 1;
        }
        span.name {
          font-size: 12px;
          font-weight: bold;
          color: #303030;
          text-align: right;
        }
        span.type {
          font-size: 10px;
          font-weight: bold;
          color: #646464;
          white-space: nowrap;
        }
        .mini {
          font-size: 10px;
        }
        i.ac {
          font-size: 16px;
          padding: 8px;
          margin-right: 8px;
          border-radius: 50%;
          background-color: rgba($color: #000000, $alpha: 0.05);
        }
        i.ac:hover {
          background-color: rgba($color: #000000, $alpha: 0.15);
        }
      }
      .item:nth-child(2n+1) {
        background-color: rgba($color: #000000, $alpha: 0.02);
      }
    }
    .noResult {
      height: 192px;
      i {
        font-size: 24px;
        color: rgba($color: #000000, $alpha: 0.25);
        margin-bottom: 8px;
      }
      span {
        font-size: 12px;
        width: 80%;
        text-align: center;
      }
      .mini {
        font-size: 12px;
        cursor: pointer;
        margin-top: 16px;
        padding: 4px 8px;
        border-radius: 16px;
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
      .mini:hover {
        background-color: rgba($color: #000000, $alpha: 0.08);
      }
    }
  }
</style>
